import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cryptoName',
})
export class CryptoNamePipe implements PipeTransform {
  transform(value: string): any {
    const walletTypes: Record<string, string> = {
      BTC: 'Bitcoin',
      ETH: 'Ethereum',
      BCH: 'Bitcoin Cash',
      XRP: 'Ripple',
      LTC: 'Litecoin',
      DOGE: 'Dogecoin',
      USDT: 'Tether',
    };
    return walletTypes[value] || value;
  }
}
